<script setup>
const { basicRegisterTitle, openRegister } = useAuth();
</script>

<template>
  <ClientOnly>
    <div class="modal-content">
      <h6 class="modal-title">{{ $t('auth.register.quit.title') }}</h6>
      <p
        v-if="!!basicRegisterTitle"
        class="modal-text"
      >
        {{ basicRegisterTitle }}
      </p>
    </div>

    <div class="modal-footer">
      <button
        class="btn btn-cta h-[50px] bg-auth-button-bg text-auth-button-text w-full"
        @click="openRegister()"
      >
        {{ $t('auth.register.quit.cancel') }}
      </button>
      <button
        class="btn-link"
        @click="closeModal()"
      >
        {{ $t('auth.register.quit.confirm') }}
      </button>
    </div>
  </ClientOnly>
</template>

<style scoped lang="scss">
.modal-content {
  @apply w-full pt-10 px-5 md:pt-16 text-center;
  .modal-title {
    @apply text-2xl md:text-2xl text-auth-texts mb-4 md:mb-3;
  }
  .modal-text {
    @apply text-auth-texts/60 text-sm;
  }
}
.modal-footer {
  @apply p-5 text-center;

  .btn {
    @apply my-4 md:my-5;
  }

  .btn-link {
    @apply text-auth-texts/70 text-sm cursor-pointer;
  }
}
</style>
